(function() {

    'use strict';
    angular.module('app')
        .controller("authenticatorController", ['$scope', '$location', '$routeParams', 'accountsService', authenticatorController]
            );

    function authenticatorController($scope, $location, $routeParams, accountsService) {

    }
})();